module.exports = __webpack_public_path__ + "img/0-md.82c6983a.jpg";